import React from 'react';

const ContentDe = () => {
  return (
    <>
      <h2>Likiee GmbH Cookie-Richtlinie</h2>
      <p>Wirksam ab: 17. November 2023</p>
      <p>
        Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website unter{' '}
        <a href='https://likiee.com'>https://likiee.com</a> zu verbessern. Diese Cookie-Richtlinie ist Bestandteil der
        Datenschutzrichtlinie der Likiee GmbH. Sie befasst sich mit der Verwendung von Cookies zwischen Ihrem Gerät und
        unserer Website.
      </p>
      <p>
        Wir geben auch grundlegende Informationen über Drittanbieterdienste an, die möglicherweise ebenfalls Cookies im
        Rahmen ihres Dienstes verwenden. Diese Richtlinie gilt nicht für deren Cookies.
      </p>
      <p>
        Wenn Sie keine Cookies von uns akzeptieren möchten, sollten Sie Ihren Browser anweisen, Cookies von{' '}
        <a href='https://likiee.com'>https://likiee.com</a> abzulehnen. In einem solchen Fall können wir Ihnen
        möglicherweise bestimmte Inhalte und Dienstleistungen nicht bereitstellen.
      </p>
      <h3>Was ist ein Cookie?</h3>
      <p>
        Ein Cookie ist ein kleines Datenstück, das eine Website auf Ihrem Gerät speichert, wenn Sie sie besuchen. Es
        enthält in der Regel Informationen über die Website selbst, einen eindeutigen Identifikator, der es der Website
        ermöglicht, Ihren Webbrowser bei Ihrer Rückkehr zu erkennen, zusätzliche Daten, die dem Zweck des Cookies
        dienen, und die Lebensdauer des Cookies selbst.
      </p>
      <p>
        Cookies werden verwendet, um bestimmte Funktionen zu aktivieren (z. B. das Anmelden), die Nutzung der Website zu
        verfolgen (z. B. Analysen), Ihre Benutzereinstellungen zu speichern (z. B. Zeitzone,
        Benachrichtigungseinstellungen) und Ihre Inhalte zu personalisieren (z. B. Werbung, Sprache).
      </p>
      <p>
        Von der besuchten Website festgelegte Cookies werden in der Regel als First-Party-Cookies bezeichnet. Sie
        verfolgen in der Regel nur Ihre Aktivitäten auf dieser bestimmten Website.
      </p>
      <p>
        Von anderen Websites und Unternehmen festgelegte Cookies (Drittanbieter) werden als Drittanbieter-Cookies
        bezeichnet. Sie können verwendet werden, um Sie auf anderen Websites zu verfolgen, die denselben
        Drittanbieterdienst verwenden.
      </p>
      <h3>Arten von Cookies und wie wir sie verwenden</h3>
      <h4>Leistungscookies</h4>
      <p>
        Leistungscookies verfolgen, wie Sie eine Website während Ihres Besuchs nutzen. In der Regel handelt es sich um
        anonyme und aggregierte Informationen, wobei Informationen über alle Website-Benutzer erfasst werden. Sie helfen
        Unternehmen dabei, Besuchermuster zu verstehen, Probleme oder Fehler zu identifizieren, die Benutzer
        möglicherweise haben, und bessere strategische Entscheidungen zur Verbesserung des Website-Erlebnisses ihrer
        Zielgruppe zu treffen. Diese Cookies können von der Website, die Sie besuchen (First-Party), oder von
        Drittanbieterdiensten gesetzt werden. Sie sammeln keine persönlichen Informationen über Sie.
      </p>
      <p>Wir verwenden Leistungscookies auf unserer Website.</p>
      <h3>Wie können Sie die Verwendung von Cookies auf unserer Website kontrollieren?</h3>
      <p>
        Sie haben das Recht zu entscheiden, ob Sie Cookies auf unserer Website akzeptieren oder ablehnen möchten. Sie
        können Ihre Cookie-Einstellungen in unserem Cookie-Einwilligungs-Manager verwalten. Der
        Cookie-Einwilligungs-Manager ermöglicht es Ihnen, auszuwählen, welche Kategorien von Cookies Sie akzeptieren
        oder ablehnen. Essentielle Cookies können nicht abgelehnt werden, da sie für die Bereitstellung der Dienste auf
        unserer Website unbedingt erforderlich sind.
      </p>
      <p>
        Sie können Ihre Cookie-Einstellungen auch über die Verwaltung der Einstellungen Ihres Webbrowsers festlegen oder
        ändern. Da jeder Webbrowser unterschiedlich ist, sollten Sie die Anweisungen in Ihrem Webbrowser konsultieren
        (typischerweise im "Hilfe"-Abschnitt). Wenn Sie sich dafür entscheiden, Cookies abzulehnen oder zu deaktivieren,
        können Sie die Website dennoch nutzen, obwohl einige Funktionen der Website möglicherweise nicht für Sie
        verfügbar sind.
      </p>
      <h3>Wie oft werden wir diese Cookie-Richtlinie aktualisieren?</h3>
      <p>
        Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren, um Änderungen an den von uns verwendeten
        Cookies und verwandten Technologien oder aus anderen betrieblichen, rechtlichen oder regulatorischen Gründen
        widerzuspiegeln.
      </p>
      <p>
        Bei jeder Nutzung unserer Website gilt die jeweils aktuelle Version der Cookie-Richtlinie. Wenn Sie unsere
        Website nutzen, sollten Sie das Datum dieser Cookie-Richtlinie überprüfen (das oben in diesem Dokument angezeigt
        wird) und etwaige Änderungen seit der letzten Version überprüfen.
      </p>
      <h3>Wo können Sie weitere Informationen erhalten?</h3>
      <p>
        Für Fragen oder Bedenken bezüglich unserer Cookie-Richtlinie können Sie uns über die folgenden Kontaktdaten
        erreichen:
      </p>
      <p>
        Pavel Kirakosyan
        <br />
        info@likiee.com
      </p>
    </>
  );
};

export default ContentDe;
